import createElement from "./createElement";
const trashIcon = `
<svg style="width:30px; height:30px; fill:#a8a8a8;"  viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"></path>
</svg>
`
const popconfirm = async () => {
  const isPopconfirmOpen = document.querySelector('.popconfirm');
    if (isPopconfirmOpen) {
      return
    }

    const popconfirm = createElement('div', 'popconfirm', ['popconfirm', 'd-flex', 'flex-column']);
    const popconfirmMessage = createElement('div', 'popconfirm-message', ['popconfirm-message', 'd-flex', 'flex-column'], {}, 'Do you want to discard the AI response?');
    const popconfirmBtns = createElement('div', 'popconfirm-buttons', ['popconfirm-buttons']);
    const acceptBtn = createElement('button', 'popconfirm-accept', ['button-discard', 'popconfirm-accept'], {}, 'Discard');
    const cancelBtn = createElement('button', 'popconfirm-cancel', ['button-cancel', 'popconfirm-cancel'], {}, 'Cancel');
    popconfirm.insertAdjacentHTML('afterbegin', trashIcon);
    popconfirmBtns.append(acceptBtn, cancelBtn);
    popconfirm.append(popconfirmMessage, popconfirmBtns);

    const backdrop = createElement('div', 'backdrop', ['popconfirm-backdrop']);
    document.body.append(backdrop, popconfirm);

    const htmlEl = document.querySelector('html');
    htmlEl.classList.add('overflow-hidden');


    let decision = await new Promise((resolve) => {
        acceptBtn.addEventListener('click', () => {
            isAiThinking = false
            resolve(true);
        })
        cancelBtn.addEventListener('click', () => {
            resolve(false);
        })
        backdrop.addEventListener('click', () => {
            resolve(false);
        })
    })

    removePopconfirm();
    return decision;
};

const removePopconfirm = () => {
    const backdrop = document.querySelector('.popconfirm-backdrop');
    const popconfirm = document.querySelector('.popconfirm');
    document.body.removeChild(backdrop);
    document.body.removeChild(popconfirm);

    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove('overflow-hidden');
};

export { popconfirm, removePopconfirm }